import React from "react";
import { updateInstituteContactDetails, updateProfileNew } from "../../../APIs/PostAPIS";
import Notification from "../../Portals/Notification/Notification";
import "./update-contact-details.style.scss";
export default function UpdateContactDetails({ data,updateIt, closeIt }) {
  const [loading, setLoading] = React.useState(false);
  const [notification, setNotification] = React.useState({
    status: false,
    title: "",
    moreDetails: "",
  });
  const [contactDetails, setContactDetails] = React.useState({
    institution_contact_name: "",
    institution_primary_email: "",
    institution_alternative_email: "",
    institution_primary_contact_no: "",
    institution_alternative_contact_no: "",
  });

  const clearNotification = () => {
    let a = setTimeout(() => {
      setNotification({
        status: false,
        title: "",
        moreDetails: "",
      });
      closeIt();
      setLoading(false);
      clearTimeout(a);
    }, [1000]);
  };
  const handleUpdate = async () => {
    try {
      setLoading(true);
      let res = await updateProfileNew( data._id,contactDetails);
      if (res.data.data) {
        updateIt()
        setNotification({
          status: true,
          title: res.data.message,
          moreDetails: "",
        });
        clearNotification();
      }
    } catch (error) {}
  };
  React.useEffect(() => {
    if (!data) return;
    setContactDetails({
      institution_contact_name: data.institution_contact_name,
      institution_primary_email: data.institution_primary_email,
      institution_alternative_email: data.institution_alternative_email,
      institution_primary_contact_no: data.institution_primary_contact_no,
      institution_alternative_contact_no:
        data.institution_alternative_contact_no,
    });
  }, [data]);
  return (
    <div onClick={() => closeIt()} className="update-contact-details">
    <Notification
      enabled={notification.status}
      title={notification.title}
      moreDetails={notification.moreDetails}
      closeIt={() =>
        setNotification({
          status: false,
          title: "",
          moreDetails: "",
        })
      }
    />
      <form
        onClick={(e) => e.stopPropagation()}
        onSubmit={(e) => {
          e.preventDefault();
          handleUpdate();
        }}
        className="ucd-modal"
      >
        <header className="ucd-m-header">
          <h5>Update Contact Details</h5>
        </header>
        <section className="ucd-m-body">
          <div className="fancy-input-wrapper">
            <span>Full name</span>
            <input
              required
              value={contactDetails.institution_contact_name}
              onChange={(e) =>
                setContactDetails({
                  ...contactDetails,
                  institution_contact_name: e.target.value,
                })
              }
              placeholder=""
            />
          </div>
          <div className="fancy-input-wrapper phone">
            <span>Mobile Number</span>
            <div>
              <input value="+91" disabled type="" />
              <input
                required
                value={contactDetails.institution_primary_contact_no}
                onChange={(e) =>
                  setContactDetails({
                    ...contactDetails,
                    institution_primary_contact_no: e.target.value,
                  })
                }
                pattern="^(\d){9,12}$"
                placeholder="XXXXXXXXXX"
              />
            </div>
          </div>

          <div
            className={`fancy-input-wrapper phone ${
              contactDetails.institution_primary_contact_no &&
              contactDetails.institution_primary_contact_no ===
                contactDetails.institution_alternative_contact_no
                ? "error"
                : ""
            }`}
          >
            <span>Alternate Mobile Number</span>
            <p>Use different number</p>
            <div>
              <input value="+91" disabled type="" />
              <input
                required
                value={contactDetails.institution_alternative_contact_no}
                onChange={(e) =>
                  setContactDetails({
                    ...contactDetails,
                    institution_alternative_contact_no: e.target.value,
                  })
                }
                pattern="^(\d){9,12}$"
                placeholder="XXXXXXXXXX"
              />
            </div>
          </div>
          <div className="fancy-input-wrapper">
            <span>Email ID</span>
            <input
              required
              value={contactDetails.institution_primary_email}
              onChange={(e) =>
                setContactDetails({
                  ...contactDetails,
                  institution_primary_email: e.target.value,
                })
              }
              placeholder=""
              type="email"
            />
          </div>

          <div
            className={`fancy-input-wrapper ${
              contactDetails.institution_primary_email &&
              contactDetails.institution_primary_email ===
                contactDetails.institution_alternative_email
                ? "error"
                : ""
            }`}
          >
            <span>Alternate Email ID</span>
            <p>Use different email</p>
            <input
              required
              value={contactDetails.institution_alternative_email}
              onChange={(e) =>
                setContactDetails({
                  ...contactDetails,
                  institution_alternative_email: e.target.value,
                })
              }
              placeholder=""
              type="email"
            />
          </div>
        </section>
        <footer>
          <button>{loading ? "Updating...." : "Update"}</button>
        </footer>
      </form>
    </div>
  );
}
